import React from 'react';

import { Skeleton } from '@mui/material';

import { useGetTourOfferSummary } from '~/hooks/apis/tours/useTourOffers';

interface Props {
  tourOfferId: string;
}

export default function TourOfferName({ tourOfferId }: Props) {
  const { data: offer, isLoading } = useGetTourOfferSummary(tourOfferId);
  if (isLoading) {
    return <Skeleton width={240} sx={{ display: 'inline-block' }} />;
  }
  return <>{offer?.name ?? tourOfferId}</>;
}
